<template>
    <article class="card card-link">
        <router-link :to="{ name: `${routerLinkName}`, params:{deviceId: deviceId}}" class="card-body">
            <div class="alert alert-info alert-sm" v-if="device.repeat_repair_order">
                <animated-info></animated-info>
                <div class="alert-content">This device is a repeat repair.</div>
            </div>
            <div class="alert alert-danger alert-sm" v-if="assetsAwaitingParts">
                <animated-error></animated-error>
                <div class="alert-content">Some assets are awaiting parts</div>
            </div>
            <div class="media">
                <div class="media-left">
                    <img v-if="device.version_image" :src="device.version_image" class="img-2x">
                    <template v-if="!device.version_image">
                        <icon-mobile v-if="device.type === 'phone'" size="2x" class="icon-all-muted"></icon-mobile>
                        <icon-tablet v-if="device.type === 'tablet'" size="2x" class="icon-all-muted"></icon-tablet>
                    </template>
                </div>
                <div class="media-body">
                    <h5 class="mb-2">{{ device.title_with_colour }}</h5>
                    <div class="row">
                        <dl class="col-md-6 mb-3">
                            <dt class="mb-0">IMEI</dt>
                            <dd>
                                <template v-if="device.imei">{{ device.imei }}</template>
                                <template v-if="!device.imei">Unavailable</template>
                            </dd>
                        </dl>
                        <dl class="col-sm-6 mb-3">
                            <dt class="mb-0">Board</dt>
                            <dd>
                                <template v-if="device.board">{{ device.board }}</template>
                                <template v-if="!device.board">--</template>
                            </dd>
                        </dl>
                        <dl class="col-sm-6 mb-3" v-if="device.so_number">
                            <dt class="mb-0">SO Number</dt>
                            <dd>
                                {{ device.so_number }}
                            </dd>
                        </dl>
                        <dl class="col-sm-6 mb-3" v-if="device.customer_reference">
                            <dt class="mb-0">Customer Ref</dt>
                            <dd>
                                {{ device.customer_reference }}
                            </dd>
                        </dl>
                    </div>
                    <div class="row">
                        <dl class="col-sm-12 mb-3">
                            <dt class="mb-0">Repairs</dt>
                            <dd v-for="repair in repairList" :key="repair.id">
                                {{ repair.title }}
                            </dd>
                        </dl>
                    </div>
                </div>
                <div class="media-right align-self-center first-xs first-sm">
                    <div class="badge" v-if="device.status_title" :class="{'badge-success': device.complete, 'badge-warning': !device.complete}">
                        {{ device.status_title }}
                    </div>
                </div>
            </div>
        </router-link>
      <div class="card-footer d-flex flex-wrap align-items-center">
        <a href="#" class="text-link mr-3" @click="addNote()">
          <i class="fa fa-plus mr-1"></i> Add Note
        </a>
        <b-dropdown menu-class="bg-body" variant="link" no-caret toggle-class="text-link p-0" class="copy-dropdown">
          <template #button-content>
            <i class="fa fa-copy mr-1"></i> Copy Details
          </template>
          <b-dropdown-item @click="copyToClipboard('device')">
            <i class="fa fa-mobile mr-2"></i> Device Details
          </b-dropdown-item>
          <b-dropdown-item @click="copyToClipboard('imei')">
            <i class="fa fa-barcode mr-2"></i> IMEI / SN
          </b-dropdown-item>
          <b-dropdown-item @click="copyToClipboard('so')">
            <i class="fa fa-file-text mr-2"></i> Service Order
          </b-dropdown-item>
          <b-dropdown-item @click="copyToClipboard('customer_ref')">
            <i class="fa fa-user mr-2"></i> Customer Ref
          </b-dropdown-item>
        </b-dropdown>
      </div>

    </article>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {

        props:['device', 'job', 'assetsAwaitingParts'],

        data() {
            return {
                repairList: []
            }
        },

        mounted() {
            let that = this;

            this.loadDeviceStatus({
                statusId: this.device.status_id
            });

            this.loadRepairsForDevice({jobId: this.job.id, deviceId: this.device.id}).then(function(data) {
                that.repairList = data;
            });

        },

        computed: {
            ...mapGetters([
                "additionalData",
                "deviceStatus"
            ]),

            deviceId() {
                return this.device.id;
            },

            routerLinkName() {
                if (this.device.current_step && this.device.current_step !== 'job') {
                    // Disabling this for now, as it seems to be causing issues
                    // const now = new Date();
                    // const today = now.getFullYear() + '-' +
                    //     String(now.getMonth() + 1).padStart(2, '0') + '-' +
                    //     String(now.getDate()).padStart(2, '0');
                    //
                    // if (this.device.current_step_date && this.device.current_step_date !== today) {
                    //     return 'repair'
                    // }

                    return this.device.current_step
                }
                return 'repair'
            }
        },

        methods: {
            ...mapActions([
                "setDevice",
                "loadRepairsForDevice",
                "loadDeviceStatus",
                "setNoteableId",
                "setNoteableType",
                "setAdditionalData",
                "displayToast"
            ]),

            /** Open the note modal */
            addNote() {
                this.$emit("openNoteModal");
            },

          copyToClipboard(type) {
            let text = '';
            let label = '';
            switch (type) {
              case 'device':
                text = this.device.title_with_colour;
                label = 'Device Details';
                break;
              case 'imei':
                text = this.device.imei;
                label = 'IMEI / SN';
                break;
              case 'so':
                text = this.device.so_number;
                label = 'Service Order';
                break;
              case 'customer_ref':
                text = this.device.customer_reference;
                label = 'Customer Ref';
                break;
            }

            if (!text) {
              this.displayToast({ text: `${label} is not available`, type: 'error' });
              return;
            }

            navigator.clipboard.writeText(text).then(() => {
              this.displayToast({ text: `Copied: ${text}`, type: 'success' });
            });
          },


        }
    }
</script>
<style scoped>
.copy-dropdown >>> .dropdown-item:hover {
  color: inherit;
  background-color: #252A41;
}

.copy-dropdown >>> .dropdown-item i.fa {
  transition: none;
  animation: none;
}

</style>